<template>
  <v-container fluid class="app">
    <v-erro
      :icone="icone"
      :nomeDoErro="nomeDoErro"
      :mensagemDeErro="mensagemDeErro" />
  </v-container>
</template>

<script>
import VErro from "../components/VErro.vue"
export default {
  name: "SistemaIndisponivel",
  components: {
    VErro,
  },
  data() {
    return {
      icone: "mdi-connection",
      nomeDoErro: "Sistema Indisponível",
      mensagemDeErro: "O sistema está fora do ar temporariamente.",
    }
  },
}
</script>
